import StructureList from "../../components/Table/StructureList";

const Structures = () => <StructureList />;
export default Structures;
